export const INDEPENDENT_RESOURCES = ['treeBlocks', 'cardsSettings', 'installables', 'installables/versions'];

export const USER_RESOURCES_NO_NAMESPACE = ['auth'];

export const USER_RESOURCES = [
	'widgets',
	'widgetEditor',
	'configurationEditor',
	'appLayout',
	'configurationEditor/generalConfigurationWidgetEditor',
	'configurationEditor/userConfigurationWidgetEditor',
	'selectedNode',
	'nodes',
	'selectedWorkflow',
	'selectedWorkflow/configurations',
	'selectedWorkflow/userSchemaMapper',
	'workflows',
	'selectedProject',
	'projects',
	'account',
	'accountGroups',
	'credentials',
	'elements',
	'uiElements',
	'nativeElements',
	'nativeIntegrationAccounts',
	'alerts',
	'processes',
	'processReports',
	'selectedProcess',
	'analytics',
	'workflowConfigurations',
	'onboarding',
	'notifications',
	'featureFlags',
	'inspirationCenter',
	'inboxes',
	'billing',
	'edges',
	'aiAssistantApiDocs',
	'transactionalEmailTemplate',
	'issues',
];
